// IMPORTANT: this file was generated using SVGR, please do not edit directly. Refer to the icon README.md for more info.
 
 
import type { FC } from 'react';

import { Icon, type IconProps } from './../IconWrapper';

const SvgPlugOnIcon: FC<IconProps> = ({ color, size, verticalAlign }) => (
  <Icon color={color} size={size} verticalAlign={verticalAlign}>
    <path d="M20 10v4c0 3.31-2.69 6-6 6v1c0 .55-.45 1-1 1h-2c-.55 0-1-.45-1-1v-1c-3.31 0-6-2.69-6-6v-4c0-1.1.9-2 2-2h1V3.5C7 2.67 7.67 2 8.5 2s1.5.67 1.5 1.5V8h4V3.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V8h1c1.1 0 2 .9 2 2" />
  </Icon>
);
export default SvgPlugOnIcon;
SvgPlugOnIcon.displayName = 'SvgPlugOnIcon';
